import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Longevity from './pages/Longevity';
import Wellbeing from './pages/Wellbeing';
import Resources from './pages/Resources';
import MyLogin from './pages/MyLogin';
import TopicDetail from './pages/TopicDetail';
import AreaPage from './pages/AreaPage';
import StartAssessment from './pages/StartAssessment';
import EssentialPath from './pages/EssentialPath';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import About from './pages/About';
import EditorialStandards from './pages/EditorialStandards';
import Contact from './pages/Contact';
import MedicalDisclaimer from './pages/MedicalDisclaimer';
import NotFound from './pages/NotFound';
import AuthCallback from './components/AuthCallback';
import AnalyticsPrivacy from './components/AnalyticsPrivacy';
import ConsentBanner from './components/ConsentBanner';
import MovedRedirect from './components/MovedRedirect';
import { AuthProvider } from './context/AuthContext';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppRoutes() {
  const location = useLocation();
  // Google sign-in returns to {origin}/my-login#session_id=... — process it first.
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/longevity" element={<Longevity />} />
      <Route path="/wellbeing" element={<Wellbeing />} />
      <Route path="/resources" element={<Resources />} />
      <Route path="/topics/:slug" element={<TopicDetail />} />
      <Route path="/areas/:slug" element={<AreaPage />} />
      <Route path="/start" element={<StartAssessment />} />
      <Route path="/essentials/:slug" element={<EssentialPath />} />
      <Route path="/foundations/:code" element={<MovedRedirect />} />
      <Route path="/my-login" element={<MyLogin />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/about" element={<About />} />
      <Route path="/editorial-standards" element={<EditorialStandards />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/medical-disclaimer" element={<MedicalDisclaimer />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <AnalyticsPrivacy />
          <Header />
          <main className="w-full pt-20 bg-surface min-h-screen">
            <AppRoutes />
          </main>
          <Footer />
          <ConsentBanner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
